export enum DossierCapabilityName {
    ReversePlaybackUsingReversedVideos = "ReversePlaybackUsingReversedVideos",
    ReIdentification = "ReIdentification",
}
